exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh1[data-v-47d031a0] {\n  color: green\n}\n", ""]);

